import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useParams } from 'react-router-dom'
import { addSafety, getSingleSafety, updateSafety } from '../../../actions/homeAction'

const SafetyAdd = () => {
  const [safety, setSafety] = useState({
    safety:'',
    safetyAr:'',
    priority: null,
    active: true
  })
  const [dataEdit, setDataEdit] = useState(false)

const {sfUUID} = useParams()

const dispatch = useDispatch()

const location = window.location.href.split('/')[6]

useEffect(() => {
  if(location === 'Update'){
    dispatch(getSingleSafety(sfUUID))
    setDataEdit(true)
  } else {
    setDataEdit(false)
  }
},[])

const singleSafety = useSelector(state => state.home.singleSafety)?.response
const data = singleSafety

useEffect(() => {
  setSafety({
    safety: data?.safety,
    safetyAr: data?.safetyAr,
    priority: data?.priority,
    active: data?.active === 0 ? 'false' : 'true'
  })
},[data?.safety])

console.log("safety", sfUUID);
  const onChangeHandle = (e) => {
    const {name, value} = e.target
    setSafety({...safety, [name]:value})
  }

  const onSave = () => {
    if(dataEdit){
      const payload = {
        safety:safety.safety,
        safetyAr:safety.safetyAr,
        priority:safety.priority,
        active: safety.active,
        safetyId: data.safetyId
        }
        dispatch(updateSafety(payload))
      } else {
        dispatch(addSafety(safety))
    }
  }

  return (
    <div className='main-body'>
    <div className='page-wrapper'>
      <div className='page-header'>
        <div className='row align-items-end'>
          <div className='col-lg-8'>
            <div className='page-header-title'>
              <div className='d-inline'>
                <h4>
                  { dataEdit ? `Edit : ${data?.safety}` : "Add Safety" } 
                </h4>
              </div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='page-header-breadcrumb'>
              <ul className='breadcrumb-title'>
                <li className='breadcrumb-item'>
                  <Link to='/'>
                    <i className='feather icon-home'></i>{' '}
                  </Link>
                </li>
                <li className='breadcrumb-item'>
                  <Link to='/CarDetail/Safety'>Safety</Link>
                </li>
                <li className='breadcrumb-item active'>
                { dataEdit ? "Edit Safety" : "Add Safety" } 
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className='page-body'>
        <div className='row'>
          <div className='col-sm-12'>
            <div className='card card-border-default'>
              <div className='card-block'>
                
                <div className='tab-content tabs'>
                  <div
                    className='tab-pane  active'
                    id={'car_user_'}
                    role='tabpanel'
                    aria-labelledby=''>
                      <div className=''>
        	<div className='col-md-6'>
							
						</div>

        {/* sdjkfj */}
				<div className='card-body'>
					<div className='row'>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Safety Name</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='safety'
										value={safety.safety}
										placeholder='Safety Name'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Safety Name Ar</label>
								<div className='col-sm-9'>
									<input
										type='text'
										className='form-control'
										name='safetyAr'
										value={safety.safetyAr}
										placeholder='Safety Name Ar'
										onChange={onChangeHandle}
									/>
								</div>
							</div>
						</div>

              <div className='col-md-6'>
                              <div className='form-group row'>
                                <label className='col-sm-3 col-form-label'>Priority</label>
                                <div className='col-sm-9'>
                                  <input
                                    type='number'
                                    className='form-control'
                                    name='priority'
                                    value={safety.priority}
                                    placeholder='Priority'
                                    onChange={onChangeHandle}
                                  />
                                </div>
                              </div>
                            </div>
						
						<div className='col-md-6'>
							<div className='form-group row'>
								<label className='col-sm-3 col-form-label'>Status</label>
								<div className='col-sm-9'>
									<select
										name='active'
										className='form-control'
										onChange={onChangeHandle}
										value={safety?.status}
                    >
										<option value={true} name='active'>
											Active
										</option>
										<option value={false} name='inactive'>
											Inactive
										</option>
									</select>
								</div>
							</div>
						</div>
					</div>
					<div className='card-footer'>
						<div className='row float-right p-3'>
							
							<button
								onClick={onSave}
								className='btn btn-grd-disabled mr-2'>
								<i className='icofont icofont-save'></i> {dataEdit ? "Update" : "Save"}
							</button>
							<Link to={'/CarDetail/Safety'} className='btn btn-outline-dark'>
								{' '}
								Cancel{' '}
							</Link>
						</div>
					</div>
				</div>
			</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default SafetyAdd